<template>
  <div class="psw-reset">
    <van-tabs>
      <van-tab title="忘记密码">
        <div class="icode-phone-box">
          <span class="phone-icon"></span>
          <form>
            <input
                class="login-input" 
                placeholder="请输入11位手机号"
                v-model="registerForm.phone"
                @blur="registerPhoneNumCheck"
            />
          </form>
        </div>
		<span class="error-message">{{registerPhoneError}}</span>
        <div class="icode-box">
          <span class="icode-icon"></span>
          <form>
            <input
                class="login-input"
                placeholder="请输入6位验证码"
                v-model="registerForm.code"
                @blur="registerIdentCodeCheck"
            />
          </form>
          <van-button :disabled="identCodeDisabled" @click="getIdentCode"><span v-if="reIndentCodeText">重新</span>获取验证码<span v-if="reIndentCodeNum">{{countdown}}</span></van-button>
        </div>
		<span class="error-message">{{registerIndentError}}</span>
        <div class="psw-box" v-if="this.$route.meta.title!=='bindphone'">
          <span class="password-icon"></span>
          <form>
            <input
              class="login-input"
              type="password"
              placeholder="请输入密码"
              v-model="registerForm.password"
              @blur="registerPswCheck"
            />
          </form>
        </div>
		<span class="error-message">{{registerPswError}}</span>
        <div class="repsw-box" v-if="this.$route.meta.title!=='bindphone'">
          <span class="password-icon"></span>
          <form>
            <input
              class="login-input"
              type="password"
              placeholder="请再次输入密码"
              v-model="registerForm.repassword"
              @blur="registerRePswCheck"
            />
          </form>
        </div>
		<span class="error-message">{{registerRePswError}}</span>
        <button :class="{'pswset-submit':true,'btn-submiting':Btnsubmiting}" @click="submitPswResetForm" ref="pswSubmitBtn">确定</button>
        <router-link to="/login" class="back-to-submit" tag="p">返回登录</router-link>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import {AxiosOld} from '@/assets/api/axios'
import {phoneNumCheck,identCodeCheck} from '@/assets/api/validate'
import {agreeOnText} from '@/assets/api/agreeOnText'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
  name: 'Form',
  data(){
    return{
      timer:'',                           //重新获取验证码倒计时
      Btnsubmiting:false,                 //表单提交中按钮样式
      reIndentCodeText:false,             //显示重新获取验证码汉字
      reIndentCodeNum:false,              //显示重新获取和验证码倒计时数字
      identCodeDisabled:true,             //控制获取验证码按钮可点击状态
      countdown:30,                       //重新获取验证码倒计时
      submitBtnDisabled:false,            //控制提交按钮防止重复提交表单      
      
      registerPhoneError:'',              //修改密码时手机号码出错
      registerIndentError:'',             //修改密码时填写的验证码不足6位
      registerPswError:'',                //修改密码输入密码错误提示
      registerRePswError:'',              //修改密码输入密码错误提示
      registerForm: {                     //修改密码表单提交
        phone:'',
        code:'',
        password: '',
        repassword: '',
      }
    }
  },
  methods:{
    //修改密码表单手机号码验证
    registerPhoneNumCheck(){
      if(!phoneNumCheck(this.registerForm.phone)){
        this.registerPhoneError="请输入正确手机号"
        this.identCodeDisabled=true
        return false
      }else{
        return true
      }
    },
    //修改密码表单验证码验证
    registerIdentCodeCheck(){
      if(identCodeCheck(this.registerForm.code)){
        this.registerIndentError=""
        return true
      }else{
        this.registerIndentError="请输入正确验证码"
        return false
      }
    },
    //修改密码表单密码验证
    registerPswCheck(){
      if(this.registerForm.password==""&&this.registerForm.repassword==""){
        this.registerPswError="请输入密码"
        return false
      }else{
        this.registerPswError=""
        return true
      }
    },
    //修改密码表单再次输入密码验证
    registerRePswCheck(){
      if(this.registerForm.repassword==""){
        this.registerRePswError="请再次输入密码"
        return false
      }else{
        this.registerRePswError=""
        return true
      }
    },
    //修改密码表单获取验证码
    getIdentCode(){
      AxiosOld.post('sendsms',{"phone":this.registerForm.phone,"login":1})
      .then(
        response=>{
          if(response.data.code==200&&response.data.status==='success'){
            this.identCodeDisabled=true;
            this.reIndentCodeText=true;
            this.reIndentCodeNum=true;
            this.timer=setInterval(()=>{
              this.countdown-=1;
            },1000)
          }
        }
      )
      .catch(
        error=>{
          this.$swal({
			text:'网络错误 请稍后重试',
			showConfirmButton:false,
			width:'6rem',
			padding:'0.5rem',
			timer:1200,
			imageWidth:50,
			imageHeight:50,
			imageUrl:notifyIcon,
			timerProgressBar: true
		 })
        }
      )
    },
    //修改密码表单提交
    submitPswResetForm(){
      this.registerPhoneNumCheck()
      this.registerIdentCodeCheck()
      this.registerPswCheck()
      this.registerRePswCheck()
      if(this.registerForm.password!==this.registerForm.repassword){
        this.registerPswError=this.registerRePswError="两次输入密码不一致"
        return false
      }
      let validateRes=!this.registerPhoneError&&!this.registerIndentError&&!this.registerPswError&&!this.registerRePswError
      if(validateRes){
        this.Btnsubmiting=true
        this.submitBtnDisabled=true
        this.$refs.pswSubmitBtn.innerHTML="提交中..."
        AxiosOld.post('editpwd',this.registerForm).then(
          response=>{
            if(response.data.data.errcode==1000&&response.data.code==200){
              this.Btnsubmiting=false
              this.submitBtnDisabled=false
              this.$refs.pswSubmitBtn.innerHTML="确定"
              this.registerIndentError="验证码错误"
            }
            else if(response.data.data.errcode==1001&&response.data.code==200){
              this.Btnsubmiting=false
              this.submitBtnDisabled=false
              this.$refs.pswSubmitBtn.innerHTML="确定"
              this.registerIndentError="验证码错误"
            }else{
              this.$swal({
					text:'密码修改成功',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:800,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				});
				setTimeout(()=>{
					location.href='/login'
				},800)
            }
          }
        )
        .catch(
          error=>{
            this.Btnsubmiting=false
            this.submitBtnDisabled=false
            this.$refs.pswSubmitBtn.innerHTML="确定"
            this.$swal({
				text:'网络错误 请稍后重试',
				showConfirmButton:false,
				width:'6rem',
				padding:'0.5rem',
				timer:1200,
				imageWidth:50,
				imageHeight:50,
				imageUrl:notifyIcon,
				timerProgressBar: true
			})
          }
        )
      }
    }
  },
  watch:{
    //监听修改密码表单手机号输入
    "registerForm.phone":function(){
      if(this.registerForm.phone.lenght!==11){
        this.identCodeDisabled=true
      }
      if(this.registerForm.phone.length===11){
        AxiosOld.get("/phone/info",{params:{"phone":this.registerForm.phone}})
        .then(
          response=>{
            if(response.data.data===0){
                this.identCodeDisabled=true
                this.registerPhoneError="该手机号未注册"
            }
            else if(response.data.data===1){
              this.identCodeDisabled=false
              this.registerPhoneError=""
            }
          }
        )
      }
    },
    //重新获取验证码倒计时显示
    countdown:function(){
      if(this.countdown<=0){
        clearInterval(this.timer);
        this.reIndentCodeNum=false;
        this.identCodeDisabled=false;
        this.countdown=30;
      }
    },
    "registerForm.code":function(val){
      if(val.length>6){
          this.registerForm.code=val.substring(0,6)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.psw-reset{
		padding-top:180px;
		width:590px;
		margin:0 auto;
	}
	input::-webkit-input-placeholder{
		color: #ccc !important;
	}
	input:-moz-placeholder{
		color: #ccc !important;
	}
	input::-moz-placeholder{
		color: #ccc !important;
	}
	input:-ms-input-placeholder{
		color: #ccc !important;
	}
	.error-message{
		color:#bf0000;
		padding-left:20px;
		padding-top:6px;
		font-size:20px;
		height:20px;
		display:block;
		margin-bottom:20px;
	}
	.btn-submiting{
		background:#dd8080 !important;
	}
	.van-tabs__line{
		width:30px !important;
		background-color:#bf0000 !important;
		height:6px;
	}
	.van-tabs--line .van-tabs__wrap{
		height:60px !important;
	}
	.van-tab__text{
		font-size:28px !important;
		color:#302D2D;
	}
	.van-tab--active{
		.van-tab__text{
			font-size:30px !important;
			color:#222;
			font-weight:bold;
		}
	}
	.icode-phone-box,.icode-box,.psw-box,.repsw-box{
		position:relative;
		.phone-icon,.password-icon{
			display:inline-block;
			background:red;
			position:absolute;
			top:50%;
			left:24px;
			transform:translateY(-13px);
		}
		.phone-icon{
			width:22px;
			height:26px;
			background:url('../assets/img/phoneicon.png') no-repeat;
			background-size:100% 100%;
		}
		.password-icon{
			width:26px;
			height:26px;
			background:url('../assets/img/pswicon.png') no-repeat;
			background-size:100% 100%;
		}
	}
	.pswset-submit{
		width:586px;
		height:70px;
		line-height:70px;
		text-align:center;
		color:#fff;
		font-size:24px;
		background:#bf0000;
		border-radius:35px;
		margin-bottom:50px;
		border:none;
	}
	.pswset-submit:active{
		background:#DD8386;  
	}
	.back-to-submit{
		font-size:24px;
		color:#999;
		text-align:center;
	}
	.agree-font-size{
		font-size:20px !important;
	}
	.agree-color{
		color:#222;
	}
	.van-overlay{
		height:100%;
		overflow:scroll !important;
	}
	.agreement-content{
		padding:60px 46px;
		background:#fff;
		position:relative;
		.close-agreement{
			position:absolute;
			top:30px;
			right:20px;
		}
	}
</style>
